import { render, staticRenderFns } from "./VisitRecordDetail.vue?vue&type=template&id=3e2f44c5&scoped=true"
import script from "./VisitRecordDetail.vue?vue&type=script&lang=js"
export * from "./VisitRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./VisitRecordDetail.vue?vue&type=style&index=0&id=3e2f44c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f44c5",
  null
  
)

export default component.exports